import { Link } from "react-router-dom";

import Seo from "../../components/Seo";
import { seoFromPublicPage } from "../../seo/publicPages";
import LegalPublicLayout from "./LegalPublicLayout";
import { LegalSectionBody } from "./LegalSectionBody";
import type { LegalSectionBlock } from "./legalSectionTypes";

const sections: LegalSectionBlock[] = [
  {
    title: "1. Operatorul de date",
    content: "Operatorul datelor cu caracter personal este:",
    bullets: [
      "Visaj Technologies SRL",
      "CUI: 40191040",
      "Sediu: Strada Rândunicii nr. 9, Giroc, Timiș, România",
      "Email: aifoiparcurs@visaj.ro",
      "Telefon: 0726 678 127",
    ],
  },
  {
    title: "2. Ce date cu caracter personal colectăm",
    content: "În cadrul aplicației AiFoiParcurs pot fi colectate următoarele categorii de date:",
    groups: [
      {
        label: "Date de identificare",
        items: [
          "nume și prenume",
          "adresă email",
          "număr de telefon",
          "date firmă (denumire, CUI, adresă)",
        ],
      },
      {
        label: "Date operaționale",
        items: [
          "date vehicul",
          "trasee și locații parcurse",
          "puncte de interes",
          "kilometri și deplasări",
        ],
      },
      {
        label: "Date privind alimentările",
        items: ["număr bon", "cantitate alimentată", "preț", "dată alimentare"],
      },
      {
        label: "Date tehnice",
        items: ["adresă IP", "cookie-uri", "date autentificare cont"],
      },
    ],
  },
  {
    title: "3. Scopul prelucrării datelor",
    content: "Datele sunt prelucrate pentru:",
    bullets: [
      "furnizarea serviciilor AiFoiParcurs",
      "generarea foilor de parcurs",
      "validarea datelor introduse",
      "gestionarea conturilor utilizatorilor",
      "procesarea plăților",
      "emiterea facturilor",
      "suport tehnic",
      "îmbunătățirea serviciilor",
    ],
  },
  {
    title: "4. Temeiul legal al prelucrării",
    content: "Prelucrarea datelor se bazează pe:",
    bullets: [
      "executarea contractului (utilizarea aplicației)",
      "obligații legale (facturare, contabilitate)",
      "interes legitim (securitate, prevenirea fraudelor)",
      "consimțământ (cookie-uri opționale)",
    ],
  },
  {
    title: "5. Procesarea plăților",
    content: "Plățile sunt procesate prin intermediul NETOPIA Payments.",
    bullets: [
      "datele cardului nu sunt stocate de AiFoiParcurs",
      "procesatorul de plăți gestionează securizat tranzacțiile",
      "procesatorul acționează ca operator independent de date",
    ],
  },
  {
    title: "6. Transferul datelor către terți",
    content: "Datele pot fi transmise către:",
    bullets: [
      "furnizori servicii hosting",
      "servicii geocoding (Google)",
      "servicii identificare firmă (API ANAF)",
      "procesatorul de plăți",
      "furnizori email tranzacțional",
    ],
    footer: "Datele sunt transmise doar în măsura necesară furnizării serviciului.",
  },
  {
    title: "7. Stocarea datelor",
    content: "Datele sunt stocate:",
    bullets: [
      "pe servere securizate",
      "pe durata utilizării serviciului",
      "conform obligațiilor legale de arhivare",
    ],
    footer:
      "Datele pot fi șterse la cererea utilizatorului, cu excepția celor necesare conform legislației.",
  },
  {
    title: "8. Securitatea datelor",
    content: "Implementăm măsuri tehnice și organizatorice pentru:",
    bullets: [
      "protejarea datelor împotriva accesului neautorizat",
      "criptarea comunicațiilor (HTTPS)",
      "control acces conturi",
      "backup periodic",
    ],
  },
  {
    title: "9. Drepturile utilizatorilor",
    content: "Conform GDPR, aveți următoarele drepturi:",
    bullets: [
      "dreptul de acces la date",
      "dreptul la rectificare",
      "dreptul la ștergere",
      "dreptul la restricționare",
      "dreptul la portabilitate",
      "dreptul la opoziție",
      "dreptul de a depune plângere la autoritatea competentă",
    ],
  },
  {
    title: "10. Cookie-uri",
    content: "Aplicația utilizează cookie-uri pentru:",
    bullets: ["funcționare tehnică", "autentificare", "analiză trafic"],
    footer: "Utilizatorii vor fi informați prin banner dedicat.",
  },
  {
    title: "11. Durata de păstrare a datelor",
    content: "Datele sunt păstrate:",
    bullets: [
      "pe durata existenței contului",
      "conform obligațiilor fiscale (facturi)",
      "până la solicitarea ștergerii",
    ],
  },
  {
    title: "12. Contact protecția datelor",
    content: "Pentru orice solicitare privind datele personale:",
    footer: "aifoiparcurs@visaj.ro",
  },
  {
    title: "13. Modificări ale politicii",
    content:
      "Această politică poate fi actualizată periodic. Ultima versiune va fi disponibilă pe site.",
  },
];

export default function PoliticaGdprPage() {
  return (
    <LegalPublicLayout>
      <Seo {...seoFromPublicPage("/politica-gdpr")} />
      <main className="legal-doc">
        <div className="legal-doc__inner">
          <Link to="/" className="legal-doc__back">
            Înapoi la pagina principală
          </Link>

          <div className="legal-doc__panel">
            <p className="legal-doc__eyebrow">Politica GDPR</p>
            <h1 className="legal-doc__title">Politica GDPR - Protecția datelor cu caracter personal</h1>
            <p className="legal-doc__lead">AiFoiParcurs</p>

            <div className="legal-doc__sections">
              {sections.map((section) => (
                <LegalSectionBody key={section.title} section={section} />
              ))}
            </div>
          </div>
        </div>
      </main>
    </LegalPublicLayout>
  );
}
